import { formatPriceWithCurrency, Loading } from "../../utils";
import { CartTable } from "../../ui";
import { useNavigate } from "react-router";
import { useCart } from "../cart/useCart";

export const AccountCart = () => {
    const navigate = useNavigate();
    const {
        loading,
        cartWithProducts,
        baseCost,
        checkoutReadyData
    } = useCart();

    if (loading) {
        return <Loading />;
    }

    const [isCheckoutReady, checkoutUnreadyReasons] = checkoutReadyData;

    return (
        <>
            <h1 className="section__title">
                Your cart
            </h1>

            <CartTable cartItems={cartWithProducts} />

            <div className="carttotal">
                <div className={`carttotal__coupon form`}>

                </div>
                <div className="carttotal__total">
                    <div className="carttotal__total-title">
                        Your Cart Total
                    </div>
                    <div className="carttotal__total-amount">
                        {baseCost ? formatPriceWithCurrency(baseCost) : '0.00'}
                    </div>
                    <div className="carttotal__btns">
                        <button
                            onClick={() => {
                                if (isCheckoutReady) {
                                    navigate('/checkout');
                                }
                            }}
                            title={isCheckoutReady ? "" : checkoutUnreadyReasons.join("\n")}
                            className="btn btn_cta btn_lg"
                            disabled={!isCheckoutReady}
                        >
                            <svg role="img" className="btn__ico">
                                <use href="./img/sprite.svg#lock"></use>
                            </svg>
                            SECURE CHECKOUT
                        </button>
                    </div>
                    {
                        checkoutUnreadyReasons.length > 0 && <div className="is-error">
                            <div className="form__alert is-error" style={{ margin: '0', width: '100%' }}>
                                To proceed to payment,<br /> {checkoutUnreadyReasons[0]}
                            </div>
                        </div>}
                    {checkoutUnreadyReasons.length === 0 && <div className="carttotal__note">
                        Price displayed excludes any applicable taxes and a&nbsp;handling fee.
                    </div>}
                </div>
            </div>
        </>
    );
};

export default AccountCart; 